import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=c472a12a&scoped=true"
import script from "./Usage.vue?vue&type=script&lang=ts"
export * from "./Usage.vue?vue&type=script&lang=ts"
import style0 from "./Usage.vue?vue&type=style&index=0&id=c472a12a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c472a12a",
  null
  
)

export default component.exports